module.exports = __webpack_public_path__ + "img/powered-by-syrenis-black.335d0ae2.svg";